import produce from 'immer';
import actions from './actions';

const initialState = {
	isOpen: false,
};

/* eslint-disable default-case, no-param-reassign */
const reducer = (state = initialState, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case actions.REFER_A_FRIEND_DIALOG_TOGGLE:
				draft.isOpen = action.isOpen;
				break;
		}
	});

export default reducer;
